import { Box, styled } from "@mui/material";


const PageContainerBox = styled(Box)(({ theme }) => ({
  margin: theme.spacing(3),
  minHeight: '800px',
  [theme.breakpoints.down('sm')]: {
    margin: theme.spacing(1),
  },
}));

export default PageContainerBox;
